export enum SubmitState {
    ALLOWED,
    SUBMIT_REQUIRED_ERROR = "submit-required-error",
    SUBMIT_VALIDATION_ERROR = "submit-validation-error"
}
